import Vue from 'vue'
import * as Components from './components'

export function registerCustomElements () {
    Vue.customElement('nsd-quicksearch-bar', Components.QuickSearchBar)
    Vue.customElement('nsd-second-trip-expose-season-booking-entry', Components.SecondTripExposeSeasonBooking)
    Vue.customElement('nsd-datepicker', Components.Datepicker)
    Vue.customElement('nsd-guided-booking-request', Components.GuidedBookingRequest)
    Vue.customElement('nsd-phone-input-form-group', Components.PhoneInputFormGroup)
    Vue.customElement('nsd-inquiry-traveler-container', Components.InquiryTravelerContainer)
    Vue.customElement('nsd-deal-confirmation-travellers-loader', Components.DealConfirmationTravellersLoader)
    Vue.customElement('nsd-deal-confirmation-form', Components.DealConfirmationForm)
    Vue.customElement('nsd-deal-confirmation-button', Components.DealConfirmationButton)
    Vue.customElement('nsd-whitelabel-search-bar', Components.WhitelabelSearchBar)

    Vue.customElement('nsd-navigation-menu', Components.NavigationMenu)
    Vue.customElement('nsd-off-canvas-menu', Components.OffCanvasMenu)
    Vue.customElement('nsd-date-and-price', Components.DateAndPriceSection)
    Vue.customElement('nsd-itinerary', Components.ItinerarySection)
    Vue.customElement('nsd-similar-trips', Components.TripTeaser)

    Vue.customElement('nsd-checkout-section', Components.CheckoutSection)
    Vue.customElement('nsd-trip-price', Components.TripPrice)
    Vue.customElement('nsd-sonnenklartv-header', Components.SonnenklarTvHeader)
}
